import { Navigation } from '@panwds/react-nav'
import defaultLogo from '../../images/panw-logo-new-left-nav.svg'
import TopNavigation from './TopNav'
import BottomNavigation from './BottomNav'
import './LeftNav.scss'
import type { VFC } from 'react'
import type { StoreState, OidcState, Vars } from '../../framework/stateTypes'
import type { NavItem as NavItemType } from '../../framework/microAppTypes'

type LeftNavProps = {
  leftNavDisplayItems: any
  state: StoreState
  vars: Vars
  oidc: OidcState | undefined
  logo: string | undefined
  collapsedLogo: string | undefined
  activeNavItem: NavItemType | undefined
  activeSubNavItem: NavItemType | undefined
}

const LeftNav: VFC<LeftNavProps> = ({ leftNavDisplayItems, state, vars, oidc, logo, collapsedLogo, activeNavItem, activeSubNavItem }) => {
  return (
    <Navigation
      logo={collapsedLogo || defaultLogo}
      logoUrl={'/'}
      fullName={logo || defaultLogo}
      hasCollapseController={true}
      isTwoLines={vars.two_lines_logo || false}
    >
      <TopNavigation state={state} leftNavDisplayItems={leftNavDisplayItems} activeNavItem={activeNavItem} activeSubNavItem={activeSubNavItem} />
      <BottomNavigation state={state} vars={vars} oidc={oidc} activeNavItem={activeNavItem} activeSubNavItem={activeSubNavItem} />
    </Navigation>
  )
}

export default LeftNav
